import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import TCostCentreDocumentDM from './TCostCentreDocumentDM'

export default class TCostCentreItemDM extends Data {
	public static className = 'TCostCentreItemDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	RID?: number
	SupplementId?: number
	ArticleId?: number
	Percentage?: number
	Book2?: string
	DocumentRID1?: number
	Book1?: string
	RecordTypeId?: number
	RecordMod?: number
	RecordES?: number
	RecordID?: number
	RecordState?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	PercentCalc?: number
	@Type(() => TCostCentreDocumentDM)
	DocumentRID2?: TCostCentreDocumentDM
}